import { render, staticRenderFns } from "./TravellerStayingInNepalVisaTypeWiseReport.vue?vue&type=template&id=29ce95b7&"
import script from "./TravellerStayingInNepalVisaTypeWiseReport.vue?vue&type=script&lang=js&"
export * from "./TravellerStayingInNepalVisaTypeWiseReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports